import React, { createContext, useContext, useEffect } from 'react';
import { AlbumSubtype, AlbumType, useAlbumTaxonomies } from './use-album_taxonomies';
import { TYPES, SUBTYPES } from '@app/admin/channels/channel-content-config';

type TaxonomiesContextType = {
  TYPES: AlbumType[];
  SUBTYPES: AlbumSubtype[];
  isLoading: boolean;
};

const AlbumTaxonomiesContext = createContext<TaxonomiesContextType>({
  TYPES: [],
  SUBTYPES: [],
  isLoading: true,
});

export const useAlbumTaxonomiesContext = () => useContext(AlbumTaxonomiesContext);

export function AlbumTaxonomiesProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useAlbumTaxonomies();
  
  useEffect(() => {
    if (data?.types) {
      TYPES.splice(0, TYPES.length, ...data.types);
    }
    if (data?.subtypes) {
      SUBTYPES.splice(0, SUBTYPES.length, ...data.subtypes);
    }
  }, [data]);

  return (
    <AlbumTaxonomiesContext.Provider
      value={{
        TYPES: data?.types ?? [],
        SUBTYPES: data?.subtypes ?? [],
        isLoading,
      }}
    >
      {children}
    </AlbumTaxonomiesContext.Provider>
  );
}
